import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="Back to top"
      data-testid="back-to-top-btn"
      className={`hidden md:flex fixed bottom-6 right-6 z-50 h-12 w-12 items-center justify-center rounded-full bg-brand-orange text-white shadow-lg ring-2 ring-brand-navy/20 transition-all duration-300 hover:bg-brand-orangehover hover:-translate-y-1 focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-orange/40 ${
        visible ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <ArrowUp className="h-5 w-5" strokeWidth={2.5} />
    </button>
  );
};
